import $ from 'jquery';
import slick from 'slick-carousel';
import FloatLabels from 'float-labels.js';


/* Global variables
********************************************/

var $breakpointSM = 651;


/* IE classes
********************************************/

let isIE = false;
if (/MSIE 10/i.test(navigator.userAgent)) {
	isIE = true;
	$('html').addClass('ie ie-10');
}
if (/rv:11.0/i.test(navigator.userAgent)) {
	isIE = true;
	$('html').addClass('ie ie-11');
}


/* Smooth scroll
********************************************/

const headerHeight = $( '.site-header .main-nav' ).outerHeight( true );

$('a[href*="#"]:not([href="#"])').on( 'click', function () {
	var $this = $(this);
	if ($this.parents('.js-no-smooth-scroll').length == 0 && $this.parents('.js-product-variants').length == 0) {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - headerHeight + 1
				}, 500);
				return false;
			}
		}
	}
});


/* Floating labels
********************************************/

new FloatLabels( '.c-form--has-floating-labels', {});


/* Sliders
********************************************/

$( function() {
	if ($('.js-slider-posts-mobile').length) {
		const settings = {
			mobileFirst: true,
			infinite: true,
			autoplay: false,
			adaptiveHeight: false,
			draggable: true,
			swipe: true,
			fade: false,
			variableWidth: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			dotsClass: 'c-slider__dots',
			arrows: false,
			nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--next"></a>',
			prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--prev"></a>',
			responsive: [
				{
					breakpoint: $breakpointSM - 1,
					settings: 'unslick'
				}
			]
		};

		$('.js-slider-posts-mobile').slick( settings );

		$( window ).on( 'resize orientationchange', function() {
			$('.js-slider-posts-mobile').each( function() {
				var $el = $( this );

				if ( $( window ).width() < $breakpointSM && ! $el.hasClass( 'slick-initialized' ) ) {
					$el.slick( settings );
				}
			} );
		} );
	}
} );



/* Tables
********************************************/

if ($('table').length) {
	$('table').wrap('<div class="c-table-wrapper"></div>');
}
